import { EntityModel } from 'src/core/services/data/models';
import { DataService, property } from "src/core/services/data.service";
import { BookemZulu as Model } from 'src/core/services/data/JayDataContext';

export class AirlineListDataService extends DataService<typeof Model.General.Logic.ViewModels.AirlineSummary, Model.General.Logic.ViewModels.AirlineSummary, AirlineSummary> {
    protected map(entity: Model.General.Logic.ViewModels.AirlineSummary): AirlineSummary {
        return new AirlineSummaryModel(entity);
    }

    public static make(context?: any): AirlineListDataService {
        return new AirlineListDataService(context, ctx => ctx.AirlinesSummaries);
    }
}

export class AirlineSummaryModel extends EntityModel<Model.General.Logic.ViewModels.AirlineSummary, AirlineSummary> implements AirlineSummary {

    @property<AirlineSummaryModel>(o => o.entity.id, (o, value) => o.entity.id = value)
    public id: number;

    @property<AirlineSummaryModel>(o => o.entity.title, (o, value) => o.entity.title = value)
    public title: string;

    @property<AirlineSummaryModel>(o => o.entity.iataCode, (o, value) => o.entity.iataCode = value)
    public iataCode: string;

    @property<AirlineSummaryModel>(o => o.entity.icaoCode, (o, value) => o.entity.icaoCode = value)
    public icaoCode: string;

    @property<AirlineSummaryModel>(o => o.entity.iso3Code, (o, value) => o.entity.iso3Code = value)
    public iso3Code: string;

    @property<AirlineSummaryModel>(o => o.entity.regionName, (o, value) => o.entity.regionName = value)
    public regionName: string;
}



// WEBPACK FOOTER //
// ./src/app/general/airlines/list/airline-list.data.ts